import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericRadioButton } from '../../components';
import { InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';


const InstalmentTypeInput: InputWithSource = ({ input }) => <GenericRadioButton label={input.name} input={input} />;

InstalmentTypeInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(InstalmentTypeInput);
